import { render, staticRenderFns } from "./UploadSendi.vue?vue&type=template&id=79e5ef2b&scoped=true&"
import script from "./UploadSendi.vue?vue&type=script&lang=js&"
export * from "./UploadSendi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e5ef2b",
  null
  
)

export default component.exports